import { IAction } from '@/redux/actions/action-helpers'
import { DailyAllowancesPolicyTypes } from '@/redux/actions/actions.types'
import { ApplicationState } from '@/redux/stores/types'

function dailyAllowancesPolicy(state: ApplicationState['dailyAllowancesPolicy'] = {}, action: IAction) {
	switch (action.type) {
		case DailyAllowancesPolicyTypes.GetDestinations.SUCCESS: {
			if (!action.payload.length) {
				return state
			}

			const { posCountry } = action.requestPayload
			const countryCode = posCountry.country.code

			let newDestinations = state[countryCode] ?? []

			for (const destination of action.payload) {
				const destinationIdx = newDestinations.findIndex((_destination) => _destination.id === destination.id)

				newDestinations =
					destinationIdx === -1
						? [...newDestinations, destination]
						: newDestinations.toSpliced(destinationIdx, 1, {
								...newDestinations[destinationIdx],
								rates: [...newDestinations[destinationIdx].rates, ...destination.rates],
							})
			}

			return { ...state, [countryCode]: newDestinations }
		}
		case DailyAllowancesPolicyTypes.ClearDestinations.SUCCESS: {
			const { posCountry } = action.payload
			const countryCode = posCountry.country.code

			const { [countryCode]: _, ...rest } = state

			return rest
		}
		default:
			return state
	}
}

export default dailyAllowancesPolicy
